<template>
  <div class="flex flex-row-reverse justify-end gap-4">
    <div class="flex grow items-center gap-4">
      <Button
        id="add-to-basket"
        data-test-id="add-item-to-basket-button"
        no-padding
        type="primary"
        class="max-w-sm grow rounded-sm py-2 transition-colors duration-200"
        :class="[
          {
            'cursor-not-allowed': product.isSoldOut,
            '!bg-red font-bold hover:!border-red hover:!bg-red': showSizeError,
            'text-[19px]': !isMobile,
          },
        ]"
        :title="title"
        ignore-capitalisation
        data-qa="add-to-cart"
        @click="handleAddToBasketClick"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <span v-if="showSizeError">
          {{ $t('pdp.size_picker.select_size_error') }}
        </span>
        <span v-else-if="showBackInStockButton">
          {{ $t('back_in_stock_subscription_form.cta_button_label') }}
        </span>
        <span v-else-if="showAlreadyInCartButton">
          {{ $t('pdp.already_in_cart_label') }}
        </span>
        <span v-else>
          {{ $t('pdp.add_label') }}
        </span>
      </Button>
      <ClientOnly>
        <button
          data-test-id="add-item-to-wishlist-button"
          class="cursor-pointer rounded-full bg-platin p-2 transition-transform active:scale-95"
          data-qa="add-to-wishlist"
          :title="wishlistAriaLabel"
          :aria-label="wishlistAriaLabel"
          @click="handleToggleWishlist"
        >
          <IconHeart v-if="!isInWishlist" class="size-6" />
          <IconHeartFull v-if="isInWishlist" class="size-6" />
        </button>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import {
  useBasketHandling,
  type UseBasketHandlingProps,
} from '../../../../../../../layers/base/composables/useBasketHandling'
import { useDeviceType } from '~/composables/useDeviceType'

const props = defineProps<UseBasketHandlingProps>()

const {
  showSizeError,
  showBackInStockButton,
  showAlreadyInCartButton,
  canPurchase,
  isInWishlist,
  handleAddToBasketClick,
  handleMouseEnter,
  handleMouseLeave,
  handleToggleWishlist,
} = useBasketHandling(props)

const i18n = useI18n()
const { isMobile } = useDeviceType()

const title = computed(() => {
  return !canPurchase ? i18n.t('badge_labels.sold_out') : ''
})

const wishlistAriaLabel = computed(() => {
  return isInWishlist.value
    ? i18n.t('pdp.remove_from_wishlist')
    : i18n.t('pdp.add_to_wishlist')
})
</script>
